import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import CircleLoading from '@/components/ani/circle-loading';
import { useEffect } from 'react';

const actionMap = {
  is_login: ['登录', '授权'],
  is_verify: ['检验', '检验'],
}

const McpToolsBUActionResult = observer((props) => {
  const {
    className = '',
    event,
    mcpStore,
  } = props;

  const status = event.status;

  const store = useLocalObservable(() => ({
    countdown : 0,
    timer : null,

    setCountdown (countdown) {
      this.countdown = countdown;
    },
    doCountdown () {
      this.setCountdown(this.countdown - 1);
    },
    setTimer (timer) {
      this.timer = timer;
    }
  }));

  useEffect(() => {
    clearInterval(store.timer);
    if(status != "running"){
      store.setCountdown(0);
      return;
    }

    try{
      store.setCountdown(event.buResult.result.number);
      if(store.countdown > 0){
        store.setTimer(setInterval(() => {
          store.doCountdown();
          if(store.countdown <= 0){
            clearInterval(store.timer);
          }
        }, 1000))
      }
    } catch(e){}
  }, [event, status]);

  useEffect(() => {
    return () => {
      clearInterval(store.timer);
    }
  }, []);

  return (
    <div className={`tools-bu-action-result flex h-32px w-max max-w-full rounded-full items-center pl-10px pr-16px ${["failed", "running"].includes(status) ? "bg-[#FF3B300F]" : "bg-[#33C4810F]" } ${className}`} data-id={event.planStepId}>
      {
        status == "failed"
        ? <SVGPureIcon name={`mcp_error`} className='size-16px ml-6px text-[#FF3B30] flex-shrink-0' />
        : status == "success"
        ? <SVGPureIcon name={`bu_done`} className='size-16px ml-6px text-[#33C481] flex-shrink-0' />
        : <CircleLoading className="!size-16px ml-6px flex-shrink-0" icon="https://p1.ssl.qhimg.com/t11098f6bcd4edd531ca1556acb.png" />
      }
      <div className={`text-14px leading-20px text-black ml-10px font-bold truncate ${["failed", "running"].includes(status) ? "text-[#FF3B30]" : "text-[#33C481]"}`}>
        {
          status == "failed"
          ? `${actionMap[event?.buResult?.action]?.[0]}失败`
          : status == "success"
          ? `已成功${actionMap[event?.buResult?.action]?.[0]}`
          : `将在您${actionMap[event?.buResult?.action]?.[1]}后继续工作 ${store.countdown > 0 ? '，请在 ' + store.countdown + `s 内${actionMap[event?.buResult?.action]?.[0]}` : ''}`
        }
      </div>
    </div>
  )
});
export default McpToolsBUActionResult;